<template>
	<div class="vh-100 bg-light" style="overflow:auto;">
		<div class="row gx-0">
            <div class="col-lg-6">
                <div class="row h-75 align-items-center justify-content-center">
                    <div class="col-xxl-6 col-8">
                        <div class="text-center col-6 m-auto p-3">
                            <img :src="logo" class="img-fluid" />
                        </div>
                        <form class="auth-signin-form">
                            <div class="app--card card m-auto p-0">
                                <div class="card-body">
                                    <div class="app--card-title" v-if="!failed">
                                        <span>{{message}}</span>
                                    </div>
                                    <app--alert v-if="failed" :close="true"
                                        description="Please ask your administrator to confirm your credentials and permissions."
                                        title="Invalid credentials"
                                        type="danger"
                                    ></app--alert>
                                    <div class="d-grid mb-3">
                                        <a :href="url" class="btn btn-primary app--button">{{label}}</a>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 d-none d-lg-block">
                <auth--splash />
            </div>
        </div>
	</div>
</template>

<script>
	export default {
        computed: {
            logo() { 
                console.log(window._auth)
                return window._auth && window._auth.logo ? window._auth.logo : '/img/logo/logo.md.png'  
            },
            label() {
                return window._auth && window._auth.label ? window._auth.label : 'Sign-in' 
            },
            message() {
                return window._auth && window._auth.message ? window._auth.message : 'Start your sign-in process' 
            },
            url() {
                return window._auth && window._auth.url ? window._auth.url : '#' 
            },
            failed() {
                const params = new Proxy(new URLSearchParams(window.location.search), {
                    get: (searchParams, prop) => searchParams.get(prop),
                });
                return params && params.failed && params.failed == 'true'
            }
        },
        methods: {
            
        }
	}
</script>
